import * as Sentry from '@sentry/react';

import { setWindowLocation } from 'utils/setWindowLocation';

import { getUpcUrl } from './getUpcUrl';

export const redirectToUpc = (
  region: OP.Env,
  orgId?: number | null,
  queryParams?: Record<string, string | number | boolean> | null,
) => {
  // Should never happen but just in case
  if (!orgId) {
    Sentry.captureMessage('No orgId provided to redirectToUpc', {
      contexts: {
        debugInfo: {
          location: JSON.stringify(window.location),
          queryParams: JSON.stringify(queryParams),
          region,
        },
      },
    });
  }

  const url = new URL(`${getUpcUrl(region)}/o/${orgId}`);

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value.toString());
    });
  }

  setWindowLocation(url.toString());
};
